var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-box"},[_c('div',{staticClass:"message-title"},[_c('svg-icon',{attrs:{"icon-class":"message-success"}}),_vm._v("\n    订单支付成功\n  ")],1),_c('div',{staticClass:"message-button"},[_c('router-link',{attrs:{"to":{ name: 'home' }}},[_c('el-button',{attrs:{"type":"primary"}},[_vm._v("返回首页")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }